/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
import React, { useCallback, useContext, useEffect, useState } from "react";
import styled from "styled-components";
import * as Sentry from "@sentry/react";
import { Helmet } from "react-helmet";
import InputField from "../../components/Layout/InputField";
import Button from "../../components/Layout/Button";
// import DataTable from "../../components/Layout/Table/DataTable";
import TableData from "../../components/Layout/Table/TableData";
// import { Heading } from '../../components/Layout/Typography';
import {
  OuterContainerStyles,
  Title,
  SearchContainer,
  ExistingText,
  SearchContainerTable,
} from "../../components/Layout/Typography";
import Heading from "../../components/Layout/Heading";
import { SERVICES } from "../../components/Layout/Services";
import fetchData from "../../components/Layout/FetchData";
import {
  del,
  post,
  get,
  put,
} from "../../components/Layout/ApiHandler/apihandler";
import EditModal from "../../components/Layout/Modal";
import PageSyncCal from "../../components/Layout/PageSyncCal";
import EditIcon from "../../components/Svg/EditIcon";
import DeleteIcon from "../../components/Svg/DeleteIcon";
import { ToastAlertContext } from "../../Config/Providers/ToastAlert";
import { AlertStatus } from "../../contants";
import Loader from "../../components/Loader/Loader";
import NoData from "../../components/NoData";
import Alert from "../../components/Alert/Alert";

const DEFAULT_PAGE_SIZE = 10;

function PayableCityDetails() {
  const TITLE = "Payable City Details - BSG ContributionAdmin";
  const [cityName, setCityName] = useState("");
  const [searchText, setSearchText] = useState("");
  const [payableCityData, setPayableCityData] = useState({});
  // const [individualCityData, setIndividualCityData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [selectedCityId, setSelectedCityId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [edit, setEdit] = useState("");
  const toast = useContext(ToastAlertContext);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [openAlert, setOpenAlert] = useState(false);
  const [totalElements, setTotalElements] = useState(0);

  // const toggleAlert = () => setOpenAlert((prev) => !prev);
  // const handleAlertOpen = () => {
  //   setOpenAlert(true);
  // };

  const handleAlertClose = () => {
    setOpenAlert(false);
  };

  const handleEdit = (event) => {
    setEdit(event.target.value);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const getCityById = async (cityId) => {
    try {
      const url = `${SERVICES.PAYABLE_CITY}/${cityId}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        // console.log(data);
        setEdit(data.data.cityName);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const handleEditCity = async (cityId) => {
    setSelectedCityId(cityId);
    getCityById(cityId);
    setIsModalOpen(true);
  };
  const handleDeleteAlert = (cityId) => {
    setSelectedCityId(cityId);
    setOpenAlert(true);
  };
  const handleTotalElements = async () => {
    const url = `${SERVICES.PAYABLE_CITY}`;
    const response = await get(url);
    if (response.ok) {
      const data = await response.json();
      setTotalElements(data.data.totalElements);
    }
  };

  const handleDeleteCity = async (cityId) => {
    try {
      const url = `${SERVICES.PAYABLE_CITY}/${cityId}`;
      const response = await del(url);
      if (response.ok) {
        toast.show("Payable City Deleted Successfully", AlertStatus.SUCCESS);
        await fetchPayableCityData();
        handleAlertClose();
      } else {
        console.error("Failed to update city data");
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  const fetchPayableCityData = useCallback(async () => {
    const url = `${SERVICES.PAYABLE_CITY}?size=${DEFAULT_PAGE_SIZE}`;
    await fetchData(url, setPayableCityData, setIsLoading);
  }, []);

  const handleInputChange = (event) => {
    setSearchText(event.target.value);
  };

  // const handleSearch = async () => {
  //   console.log(searchText);
  //   if (searchText.trim() === "") {
  //     return;
  //   }

  //   // const foundCity = payableCityData.content.find((city) => city.cityName === searchText.trim());
  //   // if (foundCity) {
  //   //   setSelectedCityId(foundCity.id);

  //   //   try {
  //   //     const url = `${SERVICES.PAYABLE_CITY}/${foundCity.id}`;
  //   //     const response = await get(url);

  //   //     if (response && response.ok) {
  //   //       const data = await response.json();
  //   //       const cityDataArray = [data.data];
  //   //       setIndividualCityData(cityDataArray)
  //   //     } else {
  //   //       console.error('Failed to fetch city data');
  //   //     }
  //   //   } catch (error) {
  //   //     console.error('Error:', error);
  //   //   }
  //   // } else {
  //   //   setSelectedCityId(null);
  //   //   alert('City not found.')
  //   // }
  //   try {
  //     const url = `${SERVICES.PAYABLE_CITY}/search?keyword=${searchText}`;
  //     const response = await get(url);
  //     if (response.ok) {
  //       const data = await response.json();
  //       if (data.data.content.length === 0) {
  //         // alert("City not found");
  //         toast.show("City not found", AlertStatus.ERROR);
  //       } else {
  //         setPayableCityData(data.data);
  //       }
  //     } else {
  //       console.error("Failed to fetch city data");
  //     }
  //   } catch (error) {
  //     console.error("Error", error);
  //   }
  // };
  const handleSearch = async () => {
    // console.log(searchText);
    if (searchText.trim() === "") {
      fetchPayableCityData();
      return;
    }
    try {
      const url = `${SERVICES.PAYABLE_CITY}?size=${totalElements}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        const filteredData = data.data.content.filter((item) =>
          item.cityName.toLowerCase().includes(searchText.toLowerCase()),
        );
        if (filteredData.length === 0) {
          toast.show("Payable City Not Found", AlertStatus.ERROR);
        } else {
          setPayableCityData({ content: filteredData });
        }
      } else {
        console.error("Failed to fetch city data");
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  const handleSubmit = async () => {
    // console.log(searchText);
    if (cityName.trim() === "") {
      return;
    }
    const url = SERVICES.PAYABLE_CITY;
    const data = {
      cityName: cityName.trim(),
    };

    try {
      const response = await post(url, data);
      if (response.ok) {
        // eslint-disable-next-line no-shadow
        const data = await response.json();
        // console.log(data);
        await fetchPayableCityData();
        toast.show("Payable City Added Successfully", AlertStatus.SUCCESS);
        setCityName("");
      }
      if (response.status === 400) {
        toast.show("Something Went Wrong", AlertStatus.ERROR);
      }
    } catch (error) {
      toast.show(error.message, AlertStatus.SUCCESS);
      Sentry.captureException(error);
    }
  };

  const handleEditSubmit = async () => {
    try {
      const url = `${SERVICES.PAYABLE_CITY}/${selectedCityId}`;
      const data = {
        cityName: edit.trim(),
      };

      const response = await put(url, data);

      if (response.ok) {
        toast.show("City Update Successfully", AlertStatus.SUCCESS);
        await fetchPayableCityData();
        closeModal();
      } else {
        console.error("Failed to update city data");
      }
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };
  const handlePageChange = async (selectedPage) => {
    setIsLoading(true);
    setCurrentPage(selectedPage);
    try {
      const url = `${SERVICES.PAYABLE_CITY}?page=${selectedPage}&size=${DEFAULT_PAGE_SIZE}`;
      const response = await get(url);

      if (response && response.ok) {
        const data = await response.json();
        setPayableCityData(data.data);
      } else {
        console.error("Failed to fetch contribution data");
      }
    } catch (error) {
      // console.log(error);
      Sentry.captureException(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchPayableCityData();
  }, [fetchPayableCityData]);

  useEffect(() => {
    if (payableCityData.content) {
      const updatedTableData = payableCityData.content.map((item, index) => {
        const serialNumber = currentPage * DEFAULT_PAGE_SIZE + index + 1;
        return {
          id: item.id,
          column1: serialNumber,
          column2: item.cityName,
          column3: (
            <div
              style={{ display: "flex", gap: "25px", justifyContent: "center" }}
            >
              <EditIcon
                onClick={() => handleEditCity(item.id)}
                style={{ cursor: "pointer" }}
              />
              <DeleteIcon
                // onClick={() => handleDeleteCity(item.id)}
                // onClick={()=> setOpenAlert(true)}
                onClick={() => handleDeleteAlert(item.id)}
                style={{ cursor: "pointer" }}
              />
            </div>
          ),
        };
      });
      setTableData(updatedTableData);
    }
  }, [payableCityData.content]);

  // useEffect(() => {
  //   if (individualCityData.length > 0) {
  //     const updatedTableData = individualCityData.map((item, index)=>{
  //       return {
  //         id: item.id,
  //         column1: index+1,
  //         column2: item.cityName,
  //         column3: (
  //           <>
  //           <Btn  onClick={() => handleEditCity(item.id)}>
  //             Edit
  //           </Btn>
  //           <Btn  onClick={() => handleDeleteCity(item.id)}>
  //             Delete
  //           </Btn>
  //         </>
  //         ),
  //       }
  //     });

  //     setTableData(updatedTableData);
  //   }
  // }, [individualCityData]);
  useEffect(() => {
    handleTotalElements();
  }, []);
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
      }
    };

    window.addEventListener("keydown", handleKeyPress);

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, []);

  const tableHeaders = ["S. No.", "City Name", "Action"];
  return (
    <div style={{ width: "100%", overflow: "hidden" }}>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <PageSyncCal />
      <Heading title="Payable City Details" />
      <OuterContainerStyles>
        <Title>Payable City Details</Title>
        <SearchContainer>
          <InputField
            onChange={(e) => setCityName(e.target.value)}
            placeholder="City Name"
            customvalue={cityName}
          />
          <Button onClick={handleSubmit} disabled={isLoading}>
            + Add City
          </Button>
        </SearchContainer>
      </OuterContainerStyles>
      <OuterContainerStyles marginTop="24px" marginBottom="24px">
        <ExistingText>Existing Payable City (s)</ExistingText>
        <SearchContainerTable>
          <div style={{ width: "50%" }}>
            <InputField
              onChange={handleInputChange}
              placeholder="Search here..."
              // customvalue={searchText}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch();
                }
              }}
            />
          </div>
          <Button onClick={handleSearch}>Search</Button>
          <Btn type="button" onClick={fetchPayableCityData}>
            View All
          </Btn>
        </SearchContainerTable>
        {tableData?.length ? (
          <TableData
            tableData={tableData}
            data={payableCityData}
            headers={tableHeaders}
            onPageChange={handlePageChange}
          />
        ) : (
          !tableData?.length && isLoading === false && <NoData />
        )}
      </OuterContainerStyles>
      <EditModal
        isOpen={isModalOpen}
        handleClose={closeModal}
        onChange={handleEdit}
        handleSubmit={handleEditSubmit}
        heading="Edit City"
        placeholder="Enter City Name ..."
        initialValue={edit}
      />
      <Alert
        open={openAlert}
        onClose={handleAlertClose}
        onSubmit={() => handleDeleteCity(selectedCityId)}
      />
      {isLoading && <Loader />}
    </div>
  );
}

export default PayableCityDetails;

const Btn = styled.button`
  border: none;
  background-color: transparent;
  color: #00adf8;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
  cursor: pointer;
`;
